module.exports = __webpack_public_path__ + "img/chevron-right.5fa90a36.svg";